import { render, staticRenderFns } from "./TableReposicionConfig.vue?vue&type=template&id=dfd8acdc&scoped=true"
import script from "./TableReposicionConfig.vue?vue&type=script&lang=js"
export * from "./TableReposicionConfig.vue?vue&type=script&lang=js"
import style0 from "./TableReposicionConfig.vue?vue&type=style&index=0&id=dfd8acdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd8acdc",
  null
  
)

export default component.exports